/** Map document stored in DB / S3 (authoritative map format). */
/** Validate map dimensions and terrain array length. */
export function validateMapDocument(map) {
    const errors = [];
    const { width, height } = map.size;
    const expected = width * height;
    if (width < 20 || width > 200 || height < 20 || height > 200) {
        errors.push(`Map size must be between 20 and 200, got ${width}x${height}`);
    }
    if (map.terrain.length !== expected) {
        errors.push(`terrain length must be ${expected}, got ${map.terrain.length}`);
    }
    return errors;
}
/** Row-major index: y * width + x */
export function cellIndex(x, y, width) {
    return y * width + x;
}
export function inBounds(x, y, width, height) {
    return x >= 0 && y >= 0 && x < width && y < height;
}
//# sourceMappingURL=schema.js.map